
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mentor-all",
      function () {
        return require("private-next-pages/mentor-all.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mentor-all"])
      });
    }
  